import { render, staticRenderFns } from "./DoctorList.vue?vue&type=template&id=02819d28&scoped=true&"
import script from "./DoctorList.vue?vue&type=script&lang=js&"
export * from "./DoctorList.vue?vue&type=script&lang=js&"
import style1 from "./DoctorList.vue?vue&type=style&index=1&id=02819d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02819d28",
  null
  
)

export default component.exports